module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/scale-range-new/scale-range-new.component.css
// module id = ./src/app/admin/scale-range-new/scale-range-new.component.css
// module chunks = main